<template>
  <div id="app" :style="backgroundStyle">
    <!-- Si está autorizado, renderizamos la app -->
    <router-view v-if="isAuthorized" />

    <!-- Si NO está autorizado, bloqueamos todo con el modal -->
    <div v-else class="auth-backdrop">
      <div class="auth-modal">
        <h2 class="auth-title">Autorización requerida</h2>
        <p class="auth-subtitle">
          Por favor ingrese su nombre y el código de autorización para utilizar la aplicación.
        </p>

        <form @submit.prevent="submitAuth" class="auth-form">
          <div class="auth-field">
            <label for="nombre">Escribe tu nombre</label>
            <input
              id="nombre"
              v-model="authNombre"
              type="text"
              autocomplete="off"
              :disabled="authLoading"
            />
          </div>

          <div class="auth-field">
            <label for="pin">Inserte código de autorización</label>
            <input
              id="pin"
              v-model="authPin"
              type="password"
              autocomplete="off"
              :disabled="authLoading"
            />
          </div>

          <p v-if="authError" class="auth-error">
            {{ authError }}
          </p>

          <button
            type="submit"
            class="auth-button"
            :disabled="authLoading"
          >
            {{ authLoading ? 'Verificando…' : 'Acceder' }}
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
// import backgroundImage from '@/assets/fondo.png';

const AUTH_LS_KEY = 'hpAuth';
const AUTH_URL = 'https://flow.gestiontotal.app/webhook/elements/verificacion-pin';
const AUTH_TOKEN = 'f9129d9408789e67ad79f34a1106e756';

export default {
  data() {
    return {
      // backgroundImage,
      isAuthorized: false,
      authNombre: '',
      authPin: '',
      authLoading: false,
      authError: '',
    };
  },
  computed: {
    backgroundStyle() {
      return {
        // background: `url(${this.backgroundImage}) no-repeat center center fixed`,
        // backgroundSize: 'cover',
        background: 'linear-gradient(to right, #48465c 0%, #211f2e 50%, #151d2b 100%)',
        height: '100vh',
        width: '100%',
        // overflow: 'hidden',
      };
    },
  },
  created() {
    this.checkLocalAuth();
  },
  methods: {
    checkLocalAuth() {
      try {
        const raw = localStorage.getItem(AUTH_LS_KEY);
        if (!raw) return;

        const data = JSON.parse(raw);
        const createdAt = data.createdAt;
        if (!createdAt) {
          localStorage.removeItem(AUTH_LS_KEY);
          return;
        }

        const now = Date.now();
        const twentyOneDaysMs = 21 * 24 * 60 * 60 * 1000;

        if (now - createdAt < twentyOneDaysMs) {
          // Aún dentro de vigencia
          this.isAuthorized = true;
          this.authNombre = data.nombre || '';
          this.authPin = data.pin || '';
        } else {
          // Caducado
          localStorage.removeItem(AUTH_LS_KEY);
        }
      } catch (error) {
        console.error('Error leyendo autorización almacenada:', error);
        localStorage.removeItem(AUTH_LS_KEY);
      }
    },

    async submitAuth() {
      this.authError = '';

      // Validación básica antes de llamar al endpoint
      if (!this.authNombre || !this.authPin) {
        this.authError = 'complete todos los datos antes de enviar';
        return;
      }

      this.authLoading = true;

      try {
        const response = await fetch(AUTH_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'token-verify-permision': AUTH_TOKEN,
          },
          body: JSON.stringify({
            nombre: this.authNombre,
            pin: this.authPin,
          }),
        });

        if (!response.ok) {
          throw new Error('Error HTTP en verificación de pin');
        }

        const data = await response.json();

        if (data.success === 'ok') {
          // Guardamos en localStorage con timestamp para caducidad
          const payload = {
            nombre: this.authNombre,
            pin: this.authPin,
            createdAt: Date.now(),
          };
          localStorage.setItem(AUTH_LS_KEY, JSON.stringify(payload));

          this.isAuthorized = true; // ahora sí renderizamos la app
        } else if (data.success === 'error') {
          // Mostramos el mensaje que viene del servidor
          this.authError = data.menssage || 'Error en la verificación del pin.';
        } else {
          this.authError = 'Respuesta inesperada del servidor.';
        }
      } catch (error) {
        console.error('Error verificando pin:', error);
        this.authError =
          'No se ha podido verificar el pin. Verifique su conexión e intente nuevamente.';
      } finally {
        this.authLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: 'FormaDJRDisplay';
  src: url('@/assets/FormaDJRDisplay-Regular.otf') format('opentype');
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-family: 'FormaDJRDisplay', sans-serif !important;
}

/* Overlay de autenticación */
.auth-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999; /* por encima de todo */
}

.auth-modal {
  background: #1f2430;
  color: #ffffff;
  padding: 2rem 2.25rem;
  border-radius: 14px;
  max-width: 420px;
  width: 90%;
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.5);
  text-align: left;
}

.auth-title {
  margin: 0 0 0.5rem 0;
  font-size: 1.4rem;
  letter-spacing: 0.03em;
}

.auth-subtitle {
  margin: 0 0 1.5rem 0;
  font-size: 0.9rem;
  opacity: 0.85;
}

.auth-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.auth-field {
  display: flex;
  flex-direction: column;
  text-align: left;

  label {
    font-size: 0.8rem;
    margin-bottom: 0.25rem;
    opacity: 0.9;
  }

  input {
    padding: 0.45rem 0.7rem;
    border-radius: 8px;
    border: 1px solid #3a3f4c;
    background: #151824;
    color: #ffffff;
    font-size: 0.9rem;
    outline: none;
  }

  input:focus {
    border-color: #00bcd4;
    box-shadow: 0 0 0 1px rgba(0, 188, 212, 0.5);
  }

  input:disabled {
    opacity: 0.7;
  }
}

.auth-error {
  margin: 0;
  font-size: 0.8rem;
  color: #ff6b6b;
}

.auth-button {
  margin-top: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  font-size: 0.9rem;
  letter-spacing: 0.04em;
  background: #00bcd4;
  color: #ffffff;
  text-transform: uppercase;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
  width: 100%;
}

.auth-button:hover:enabled {
  transform: translateY(-1px);
  box-shadow: 0 5px 14px rgba(0, 188, 212, 0.55);
  background: #04c7e0;
}

.auth-button:disabled {
  opacity: 0.7;
  cursor: default;
  box-shadow: none;
}
</style>
